import { React, useEffect, useState, useRef } from "react";
import axios from "axios";
import { Toast } from "primereact/toast";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Utils from "../../Utils";

export default function AddEditDepartment() {
  const toast = useRef(null);
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [editDepartmentID, setEditDepartmentID] = useState(0);
  const [department, setDepartment] = useState();
  const [saveAction, setSaveAction] = useState("ADD");
  const [formData, setFormData] = useState({
    DepartmentName: "",
    AgeLimit: "",
    IsSeparateSalesInReport: null,
    IsAllowStaffDiscount: null,
    IsAllowDiscount: null,
  });

  const handleChange = (e) => {
    const inputValue =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setFormData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: inputValue,
      };
    });
  };

  useEffect(() => {
    if (
      location != null &&
      location.action != null &&
      location.rowData != null
    ) {
      setEditDepartmentID(location.rowData.id);
      setSaveAction("EDIT");
    }
  }, []);

  useEffect(() => {
    if (editDepartmentID > 0) {
      console.log("editDepartmentID ", editDepartmentID);
      getDepartmentForEdit(editDepartmentID);
    }
  }, [editDepartmentID]);

  const getDepartmentForEdit = (_id) => {
    console.log(_id);

    setLoading(true);
    axios
      .post(
        Utils.apiBaseURL + "departments/getbyid",
        { department_id: _id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        console.log(response);
        var dept = {
          DepartmentName: response.data.department.department_name,
          AgeLimit: response.data.department.age_limit,
          IsSeparateSalesInReport:
            response.data.department.separate_sales_in_report === 1
              ? true
              : false,
          IsAllowStaffDiscount:
            response.data.department.allow_staff_discount === 1 ? true : false,
          IsAllowDiscount:
            response.data.department.allow_discount_department === 1
              ? true
              : false,
        };
        console.log(dept);
        setFormData(dept);
      })
      .catch((ex) => {
        setLoading(false);
        if (ex.response) {
          console.log(ex.response);
        } else if (ex.request) {
          console.log(ex.request);
        } else {
          console.log("Error", ex.message);
        }
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    var apiURL = "";
    if (
      location != null &&
      location.action != null &&
      location.action === "edit"
    ) {
      apiURL = Utils.apiBaseURL + "departments/edit";
    } else {
      apiURL = Utils.apiBaseURL + "departments/add";
    }
    setLoading(true);

    axios
      .post(
        apiURL,
        { formData: formData, department_id: editDepartmentID },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        console.log("API response", response);
        if (
          response.data.status != null &&
          response.data.status === "success"
        ) {
          //toast(response.data.msg);
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: response.data.msg,
            life: 3000,
          });

          if (editDepartmentID === 0) {
            setTimeout(window.location.reload(false), 7000);
          }

          setLoading(false);
        } else {
          console.log(response.data.error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: response.data.error,
            life: 3000,
          });
        }
      })
      .catch((ex) => {
        setLoading(false);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: ex.message,
          life: 3000,
        });
      });
    return;
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">
                {editDepartmentID > 0 ? "Edit" : "Add"} Department
              </h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active">
                  {" "}
                  {editDepartmentID > 0 ? "Edit" : "Add"} Department
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <form name="frmDept" method="post" onSubmit={handleSubmit}>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">
                      {editDepartmentID > 0 ? "Edit" : "Add"} Department
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="form-group">
                      <label>Department Name *</label>
                      <input
                        type="text"
                        className="form-control"
                        name="DepartmentName"
                        value={formData.DepartmentName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Age Limit*</label>
                      <select
                        className="form-control"
                        name="AgeLimit"
                        value={formData.AgeLimit}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select</option>
                        <option value={99}>99</option>
                        <option value={18}>18</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <div className="custom-control custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="checkbox"
                          id="IsSeparateSalesInReport"
                          name="IsSeparateSalesInReport"
                          value={formData.IsSeparateSalesInReport}
                          defaultChecked={formData.IsSeparateSalesInReport}
                          onChange={handleChange}
                        />
                        <label
                          for="IsSeparateSalesInReport"
                          className="custom-control-label"
                        >
                          Separate Sales In Report
                        </label>
                      </div>
                      <div className="custom-control custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="checkbox"
                          id="IsAllowStaffDiscount"
                          name="IsAllowStaffDiscount"
                          value={formData.IsAllowStaffDiscount}
                          defaultChecked={formData.IsAllowStaffDiscount}
                          onChange={handleChange}
                        />

                        <label
                          for="IsAllowStaffDiscount"
                          className="custom-control-label"
                        >
                          Allow Staff Discount
                        </label>
                      </div>
                      <div className="custom-control custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="checkbox"
                          id="IsAllowDiscount"
                          name="IsAllowDiscount"
                          value={formData.IsAllowDiscount}
                          defaultChecked={formData.IsAllowDiscount}
                          onChange={handleChange}
                        />
                        <label
                          for="IsAllowDiscount"
                          className="custom-control-label"
                        >
                          Allow Discount
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-footer mt-4">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <input
                  type="Submit"
                  name="btnSubmit"
                  value="Submit"
                  className="btn btn-primary float-right mr-3"
                />
                <input
                  type="button"
                  name="btnCancel"
                  value="Cancel"
                  className="btn btn-secondary float-right mr-3"
                  onClick={(e) => (document.location.href = "../departments")}
                />
              </div>
            </div>
          </div>
        </section>
      </form>
    </>
  );
}
